import { createSlice } from "@reduxjs/toolkit";

const getSavedUser = () => {
  if (typeof window !== "undefined") {
    try {
      const user = localStorage.getItem("userDetails");
      return user ? JSON.parse(user) : {};
    } catch (e) {
      console.error("Error reading userDetails from localStorage:", e);
    }
  }
  return {};
};

export const initialState = {
  data: getSavedUser(),
};

export const initialProfileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setInitialProfileData: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { setInitialProfileData } = initialProfileSlice.actions;
export default initialProfileSlice.reducer;
